import {
  RequestBasePostClubTask,
  RequestBaseUpdateTask,
  RequestBasketballPostTeamTask,
  Task,
} from '@hefe/models';
import { createAsyncThunk } from '@reduxjs/toolkit';
import API from '../../../api/api';

export const fetchClubTasks = createAsyncThunk(
  'tasks/getClubTasks',
  async (_, thunkAPI) => {
    const response = await API.tasks().getClubTasks();
    return response?.data;
  }
);

export const createClubTask = createAsyncThunk(
  'tasks/createClubTask',
  async (data: RequestBasePostClubTask, thunkAPI) => {
    const response = await API.tasks().createClubTasks(data);
    return response?.data;
  }
);

export const fetchBasketballTeamTasks = createAsyncThunk(
  'tasks/getBasketballTeamTasks',
  async (data: { teamId: number; withClubTasks: boolean }, thunkAPI) => {
    const response = await API.tasks().getBasketballTeamTasks(
      data.teamId,
      data.withClubTasks
    );
    return response?.data;
  }
);

export const createBasketballTeamTask = createAsyncThunk(
  'tasks/createBasketballTeamTask',
  async (
    data: { teamId: number; request: RequestBasketballPostTeamTask },
    thunkAPI
  ) => {
    const response = await API.tasks().createBasketballTeamTask(
      data.teamId,
      data.request
    );
    return response?.data;
  }
);

export const updateTask = createAsyncThunk(
  'tasks/update',
  async (
    data: {
      taskId: number;
      request: RequestBaseUpdateTask;
    },
    thunkAPI
  ) => {
    const response = await API.tasks().update(data.taskId, data.request);
    return response?.data;
  }
);

export const deleteTask = createAsyncThunk<any, Task>(
  'tasks/delete',
  async (task: Task, thunkAPI) => {
    const response = await API.tasks().delete(task.id);
    if (response) {
      return thunkAPI.fulfillWithValue(task);
    } else {
      return thunkAPI.rejectWithValue(null);
    }
  }
);
